import { IS_SERVER } from 'src/utils/checkRenderEnv';

export const onItemClick = (slugUrl) => {
  if (!IS_SERVER) {
    const link = window.location.href.split('');
    const ifLastCharSlash = link[link.length - 1] === '/';
    window.location.href = `${window.location.href}${ifLastCharSlash ? '' : '/'}${slugUrl}`;
  }
};
